import { render, staticRenderFns } from "./OrderListItems.vue?vue&type=template&id=2edc413e&scoped=true&"
import script from "./OrderListItems.vue?vue&type=script&lang=js&"
export * from "./OrderListItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderListItems.vue?vue&type=style&index=0&id=2edc413e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc413e",
  null
  
)

export default component.exports